module.exports = __webpack_public_path__ + "static/media/17.2ac79ba5.png";